import { combineReducers } from 'redux';

import NotificationsSlice from '../../common/slices/NotificationsSlice';
import ProfileSlice from '../../common/slices/ProfileSlice';
import { InfoReducer } from '../../actions/InfoActions';
import { DemographicReducer } from '../../common/actions/DemographicActions';
import { IntegrationReducer } from '../../actions/IntegrationActions';
import LanguageSlice from '../../common/slices/LanguageSlice';
import UserSlice from '../../common/slices/UserSlice';
import ImpersonationSlice from '../../common/slices/ImpersonationSlice';
import RegistrationSlice from '../../common/slices/RegistrationSlice';

export default combineReducers({
    notifications: NotificationsSlice.reducer,
    profile: ProfileSlice.reducer,
    info: InfoReducer,
    demographics: DemographicReducer,
    integration: IntegrationReducer,
    language: LanguageSlice.reducer,
    user: UserSlice.reducer,
    impersonation: ImpersonationSlice.reducer,
    auth: combineReducers({ registration: RegistrationSlice.reducer }),
});
